var packageName = "@atlassian/recent-work-client";
var packageVersion = "1.8.5";
export { packageName, packageVersion };